import React, { useState } from "react";
import { TextField, IconButton, InputAdornment } from "@material-ui/core";
import { Link } from "@mui/material";
// import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
// import LocationOnIcon from "@mui/icons-material/LocationOn";
import { IoLocation } from "react-icons/io5";
import { BsInfoCircle } from "react-icons/bs";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import useStyles from "./styles";

const DefaultTextBox = ({ value, handleLocation, locationIconDisabled, invitedCommunityName }) => {
  const { defaultCommunity } = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  return (
    <div className={defaultCommunity}>
      <Link
        disabled={locationIconDisabled || invitedCommunityName !== null}
        component="button"
        variant="body2"
        underline="none"
        onClick={handleLocation}
        placeholder="Default Community"
        style={{
          color: "#000000",
          fontSize: "18px",
          cursor: (locationIconDisabled || invitedCommunityName !== null) ? "default" : "pointer",
          pointerEvents: locationIconDisabled && "none",
        }}
      >
        {value ? value : "Default Community"}
      </Link>
      {/* <TextField
        variant="standard"
        value={value}
        placeholder="Default Community"
        disabled={locationIconDisabled}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton disabled>
                <InfoOutlinedIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
      /> */}
      <IconButton disabled={locationIconDisabled || invitedCommunityName !== null} onClick={handleLocation}>
        <IoLocation color="#FF7B7B" fontSize={18} />
      </IconButton>
      <IconButton
        style={{ marginLeft: "auto", cursor: "pointer", outline: "none" }}
        onClick={handleClick}
        disabled={invitedCommunityName !== null}
      >
        <BsInfoCircle fontSize={18} />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Typography style={{ padding: "10px", maxWidth: "300px" }}>
          Choose a Community where you involve the most. If you don’t see a
          Community of your choice, you can request to start a new Community
          which will be assigned as your default Community upon approval.
        </Typography>
      </Popover>
    </div>
  );
};

export default DefaultTextBox;
